// extracted by mini-css-extract-plugin
export default {"AddAlertBtn":"AddAlertBtn_AddAlertBtn__F1ABj","plusIcon":"AddAlertBtn_plusIcon__sFLkJ"};